import { render, staticRenderFns } from "./FuncionariosTabela.vue?vue&type=template&id=01ad5a0d"
import script from "./FuncionariosTabela.vue?vue&type=script&lang=js"
export * from "./FuncionariosTabela.vue?vue&type=script&lang=js"
import style0 from "./FuncionariosTabela.vue?vue&type=style&index=0&id=01ad5a0d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports